export default __webpack_public_path__ + "static/media/shinilo.e6ed9959.webp";